<div class="otp-dialog-container" dir="ltr" style="z-index: 1000;">
  <div class="card">
    <div class="card-header">
      <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <div class="ms-2">
            <h4 class="me-1">
              {{ "translations.OTP" | translate }}
            </h4>
          </div>
        </div>
      </div>
    </div>

    <div class="card-body" style="z-index: 1000;">
      <p class="a-o-i">{{ "translations.Enter_Valid_OTP" | translate }}</p>
      <div class="otp-input-container">
        <ng-otp-input
          #ngOtpInput
          (onInputChange)="onOtpChange($event)"
          [config]="config"
        ></ng-otp-input>
      </div>

      <div class="button-container">
        <button
          mat-raised-button
          color="primary"
          class="default-btn"
          (click)="onSubmit()"
        >
          {{ "translations.Continue" | translate }}
        </button>
        <button
          mat-button
          color="warn"
          type="button"
          class="default-btn2"
          (click)="dialogRef.close()"
        >
          {{ "translations.Cancel" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
